// @flow
import * as React from 'react'
import TokenNavLink from './token_nav_link'
import MapToolbarStyles from 'catena/er2_styles/map_toolbar_item'

type Props = {
    idx: number,
    item: {
        active: boolean,
        icon: { default: string, active?: string },
        id: string,
        link: string,
        name: string
    },
    theme: MapToolbarStyles,
    onClick: Function,
}

function generateClassNames(props) {
    return `${props.theme.mapToolbarItem} ${props.item.active ? props.theme.mapToolbarActive : ''}`
}

// Displays a button or link that will interact with the map container
function MapToolbarItem(props: Props) {
    const classNames = generateClassNames(props)
    const iconClass = props.item.active && props.item.icon.active ?
        props.item.icon.active :
        props.item.icon.default
    return (
        <div>
            {props.item.link ?
                <TokenNavLink
                    className={classNames}
                    role="button"
                    tabIndex={props.idx}
                    to={props.item.link}
                >
                    <i className={iconClass} aria-hidden="true" title={props.item.name} />
                </TokenNavLink>
                :
                <div
                    className={classNames}
                    role="button"
                    tabIndex={props.idx}
                    onClick={(evt) => {
                        props.onClick(props.item.id, evt)
                    }}
                >
                    <i className={iconClass} aria-hidden="true" title={props.item.name} />
                </div>
            }
        </div>
    )
}

export default MapToolbarItem
